var map = {
	"./aral_komfort.svg": 3216,
	"./aral_plus.svg": 3217,
	"./bp_bonus.svg": 3218,
	"./bp_komfort.svg": 3219,
	"./bp_komfort_prepaid.svg": 3220,
	"./bp_plus.svg": 3221,
	"./fuel-card-active.svg": 3222,
	"./fuel-card-inactive.svg": 3223
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3215;